/* eslint-disable import/prefer-default-export */
export const useHeaders = {
  height: 54,
  logoHeight: 22,
  avatarSize: 32,
}
